import { createFeatureSelector, createSelector } from '@ngrx/store'
import {
  EVENT_TICKET_PACKAGES_FEATURE_KEY,
  EventTicketPackagesState,
  eventTicketPackagesAdapter,
} from './event-ticket-packages.reducer'

// Lookup the 'EventTicketPackages' feature state managed by NgRx
export const selectEventTicketPackagesState = createFeatureSelector<EventTicketPackagesState>(
  EVENT_TICKET_PACKAGES_FEATURE_KEY,
)

const { selectAll, selectEntities } = eventTicketPackagesAdapter.getSelectors()

export const selectEventTicketPackagesError = createSelector(
  selectEventTicketPackagesState,
  (state: EventTicketPackagesState) => state.error,
)

export const selectAllEventTicketPackages = createSelector(selectEventTicketPackagesState, selectAll)

export const selectAllListLoadedEventTicketPackages = createSelector(
  selectAllEventTicketPackages,
  (eventTicketPackages) => eventTicketPackages.filter((eventTicketPackage) => !eventTicketPackage.notListLoaded),
)

export const selectEventTicketPackageEntities = createSelector(
  selectEventTicketPackagesState,
  (state: EventTicketPackagesState) => selectEntities(state),
)

export const selectEventTicketPackageCount = createSelector(selectEventTicketPackagesState, (state) => state.count)

export const selectEventTicketPackageOrder = createSelector(selectEventTicketPackagesState, (state) => state.order)

export const selectStalePages = createSelector(selectEventTicketPackagesState, (state) => state.stale)

export const selectedEventTicketPackageId = createSelector(
  selectEventTicketPackagesState,
  (state: EventTicketPackagesState) => state.selectedId,
)

export const selectedEventTicketPackage = createSelector(
  selectEventTicketPackageEntities,
  selectedEventTicketPackageId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined),
)

export const selectedEventTicketPackageName = createSelector(
  selectedEventTicketPackage,
  (selectedEventTicketPackage) => selectedEventTicketPackage?.name,
)

export const selectedEventTicketPackageImages = createSelector(
  selectedEventTicketPackage,
  (selectedEventTicketPackage) => selectedEventTicketPackage?.images,
)
